import React, { useMemo, useEffect, useRef } from 'react';
import { ChartEngine } from './core/ChartEngine';
import { ChartRenderer } from './renderer/ChartRenderer';
import { FlowRunner, Flow } from './script/FlowRunner';

// 차트 전체 옵션 정의
export interface ChartOptions {
  width: number | string;  
  height: number | string; 
  backgroundColor?: string;
  padding?: number | string;
  border?: {
    color?: string;
    width?: number | string;
    radius?: number | string;
  };
}

interface Props {
  flow: Flow[];
  currentStep: number;
  options: ChartOptions;
  // Step 변경을 위한 콜백 추가
  onStepChange?: (step: number) => void;
}

export const Chart: React.FC<Props> = ({ flow, currentStep, options, onStepChange }) => {
  const engine = useMemo(() => new ChartEngine(), []);
  const runner = useMemo(() => new FlowRunner(engine), [engine]);
  const lastStepRef = useRef<number>(-1);

  // [추가] Flow(데이터셋) 자체가 바뀔 때 엔진을 물리적으로 초기화합니다.
  useEffect(() => {
    console.log("Flow Changed! Resetting Engine...");
    engine.resetAll();       // 엔진 내부 데이터/리전 삭제
    lastStepRef.current = -1; // 스텝 기록 초기화 (1단계 실행을 위해)
  }, [flow, engine]);

  useEffect(() => {
    // [수정] 스텝이 1일 때는 무조건 실행되도록 하거나, 이전 스텝보다 클 때만 실행
    if (currentStep !== 1 && currentStep <= lastStepRef.current) return;

    const flowObj = flow.find(f => f.step === currentStep);

    if (flowObj) {
      const actions = Array.isArray(flowObj.action) ? flowObj.action : [flowObj.action];
      
      actions.forEach((act: any) => {
        runner.executeCommand(act);
      });

      lastStepRef.current = currentStep;
    }
  }, [currentStep, flow, runner]);

  return (
    <div className="chart-wrapper">
      <ChartRenderer 
        engine={engine} 
        options={options} 
        onStepChange={onStepChange} 
      />
    </div>
  );
};